// extracted by mini-css-extract-plugin
export default {"root":"gDTBk","title":"loVQd"};